import React from "react";
import { Image, ImageStyle, View } from "react-native";
import UserIcon from "@assets/icons/UserIcon";
import styles from "@stylesheet";

interface AvatarHandlerProps {
  avatar: string | number | { img: string };
  avatarImageStyle?: ImageStyle;
  replacementImageStyle?: ImageStyle;
  withShadow?: boolean;
}

const AvatarHandler = ({
  withShadow,
  replacementImageStyle,
  avatar,
  avatarImageStyle,
}: AvatarHandlerProps) => {
  const [imageError, setImageError] = React.useState(false);

  const rawW =
    typeof avatarImageStyle?.width === "number"
      ? avatarImageStyle.width
      : 50;
  const rawH =
    typeof avatarImageStyle?.height === "number"
      ? avatarImageStyle.height
      : rawW;

  const side = Math.min(rawW, rawH);
  const circleRadius = side / 2;

  // ✅ Normalize image source (THIS FIXES ANDROID)
  const getSource = () => {
    if (!avatar) return null;

    // ✅ Local image (require)
    if (typeof avatar === "number") {
      return avatar;
    }

    // ✅ Remote string
    if (typeof avatar === "string") {
      return avatar.length ? { uri: avatar } : null;
    }

    // ✅ Object with img
    if (typeof avatar === "object" && avatar.img) {
      return avatar.img.length ? { uri: avatar.img } : null;
    }

    return null;
  };

  const source = getSource();
  const isLocal = typeof avatar === "number";

  const scale = isLocal ? 0.8 : 1;
  return source && !imageError ? (
    <Image
      source={source}
      onError={() => setImageError(true)}
      resizeMode="cover"
      style={[
        styles.centerEverything,
        {
          width: side,
          height: side,
          aspectRatio: 1,
          overflow: "hidden",
          transform: [{ scale }],
          borderColor: "white",
          shadowRadius: withShadow ? 20 : 0,
          shadowOpacity: withShadow ? 0.2 : 0,
          borderRadius: circleRadius,
        },
        avatarImageStyle,
        {
          borderRadius: circleRadius,
          width: side,
          height: side,
        },
      ]}
    />
  ) : (
    <View
      style={{
        width: side,
        height: side,
        borderRadius: circleRadius,
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f1f5f9",
      }}
    >
      <UserIcon
        style={[
          { width: side * 0.88, height: side * 0.88 },
          replacementImageStyle,
        ]}
      />
    </View>
  );
};

export default React.memo(AvatarHandler);